<template>
  <v-container fluid>
    <v-row dense>
      <!-- START CUSTOMER -->
      <v-col cols="12">
        <v-autocomplete rounded
                        solo
                        dark
                        color="black"
                        :label="$t('search_customer')"
                        :no-data-text="$t('no_customers_fund')"
                        v-model="cart.customerId"
                        item-value="id"
                        @change="changeAutoCompleteCustomer()"
                        :items="customers"
                        :item-text="getAutoCompleteCustomerText"
                        :loading="loading.customers"
        >
          <template v-slot:prepend>
            <v-icon dark
                    color="black"
            >mdi-account-search
            </v-icon>
          </template>

          <template v-slot:item="{ item }">
            <v-icon class="ma-2">mdi-phone</v-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.name"></v-list-item-title>
              <v-list-item-subtitle v-text="item.phone"></v-list-item-subtitle>
            </v-list-item-content>
          </template>

          <template v-slot:append>
            <v-icon dark>mdi-magnify</v-icon>
          </template>

          <template v-slot:progress>
            <v-progress-linear :indeterminate="true"
                               absolute
                               bottom
                               color="white"
                               class="mx-3 my-n2"
            ></v-progress-linear>
          </template>
        </v-autocomplete>
      </v-col>
      <!-- END CUSTOMER -->

      <!-- START CATEGORIES -->
      <v-col cols="12"
      >
        <v-skeleton-loader type="text, chip, image"
                           :loading="loading.products"
        >
          <v-col cols="12">
            <v-label color="black">{{$t('categories')}}</v-label>
          </v-col>
          <v-chip class="ma-2"
                  @click="filterProductsBy('Todo')"
          >
            <v-icon left
                    v-if="isFilteringCategories('Todo')"
            >mdi-check
            </v-icon>
            {{$t('all')}}
          </v-chip>
          <v-chip class="ma-2"
                  v-for="(category, index) in categories"
                  :key="index"
                  @click="filterProductsBy(category)"
          >
            <v-icon left
                    v-if="isFilteringCategories(category)"
            >mdi-check
            </v-icon>
            {{ category }}
          </v-chip>
        </v-skeleton-loader>
      </v-col>
      <!-- END CATEGORIES -->

      <!-- START PRODUCTS -->
      <v-col v-for="(product, index) in productsFiltered"
             :key="index"
             cols="3"
      >
        <v-hover>

          <div align="center">

            <v-card @click.stop="openDetailProductModal(product)">
              <v-img :src="product.imageUrl"
                     width="400"
                     height="100"
                     gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              >
                <v-card-text>
                  <div class="white--text text-center">{{ product.name }}</div>
                  <div class="white--text text-center">{{ product.price | currency }}</div>
                </v-card-text>
                <div class="pt-6"
                     style="position: relative;"
                     v-if="getQuantityOfThisProductInCart(product) > 0"
                >
                  <v-btn absolute
                         fab
                         small
                         right
                         top
                         color="green lighten-1"
                         class="white--text"
                         @click.stop="openCartModal()"
                  >
                    <v-icon>mdi-cart-arrow-down</v-icon>
                  </v-btn>
                </div>
              </v-img>
            </v-card>

            <touch-spin dense
                        center
                        :initial-value="getQuantityOfThisProductInCart(product)"
                        v-on:decrement="decrementProductQuantity(product)"
                        v-on:increment="incrementProductQuantity(product)"
            />
          </div>
        </v-hover>
      </v-col>
      <!-- END PRODUCTS -->

      <!-- START ACTIONS -->
      <v-col cols="12"
             v-if="hasCartProducts()"
      >
        <div class="float-right">
          <v-col cols="10">
            <p class="font-weight-black text-right">TOTAL: {{ cart.subtotalPrice | currency }}</p>
          </v-col>
          <v-col cols="12">
            <v-btn dark
                   class="ma-2"
                   @click.stop="openCartModal()"
            >
              <v-icon>mdi-cart</v-icon>
              {{ `Ver Carrito (${getProductsQuantityInCart()})` }}
            </v-btn>
            <v-btn dark
                   class="ma-2"
                   color="green"
                   @click.stop="openSummarySaleModal()"
            >Registrar Venta
            </v-btn>
          </v-col>
        </div>
      </v-col>
      <!-- END ACTIONS -->

    </v-row>

    <!-- START CART MODAL -->
    <v-dialog v-model="modal.showCart"
              persistent
              max-width="600"
    >
      <v-card>

        <v-toolbar color="transparent">

          <v-btn icon
                 color="black"
                 @click="closeCartModal()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-toolbar-title>Resumen del carrito</v-toolbar-title>
        </v-toolbar>
        <v-list subheader
                v-if="hasCartProducts()"
        >

          <v-list-item
              v-for="(product, index) in cart.products"
              :key="index"
          >
            <v-list-item-content>
              <v-list-item-title v-text="product.name"></v-list-item-title>

              <v-list-item-subtitle>{{ product.price | currency }} c/u</v-list-item-subtitle>

              <touch-spin cols="6"
                          v-bind:initial-value="getQuantityOfThisProductInCart(product)"
                          v-on:decrement="decrementProductQuantity(product)"
                          v-on:increment="incrementProductQuantity(product)"
              />
            </v-list-item-content>

            <v-list-item-action>
              <p class="font-weight-bold mb-0">{{ (product.price * product.quantity) | currency }}</p>
              <v-row class="mt-4">
                <v-col>
                  <v-btn icon
                         @click="removeProductOfCart(product)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <v-row v-else>
          <v-col cols="12">
            <p class="text-center">No hay productos en el carrito</p>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <!-- END CART MODAL -->

    <!-- START SUMMARY SALE MODAL -->
    <v-dialog v-model="modal.showSummarySale"
              max-width="800"
    >
      <v-card>
        <validation-observer v-slot="{ invalid, validate }">
          <v-toolbar color="transparent">

            <v-btn icon
                   color="black"
                   @click="closeSummarySaleModal()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>

            <v-toolbar-title>Resumen de la venta</v-toolbar-title>
          </v-toolbar>

          <form @submit.prevent="validate().then(openConfirmSaleModal())">
            <v-row align="center"
                   class="ma-0"
            >
              <v-col cols="6">
                <p class="font-weight-bold">SUBTOTAL: {{ cart.subtotalPrice | currency }}</p>
              </v-col>

              <v-col cols="6">
                <p class="font-weight-bold">DOMICILIO: {{ cart.deliveryPrice | currency }}</p>
              </v-col>
            </v-row>

            <v-row class="ma-0">
              <v-col>
                <v-chip class="ma-1"
                        @click="goSetDeliveryPriceFree()"
                        :color="isDeliverPriceSelected(0)? 'black' : 'gray'"
                        :dark="isDeliverPriceSelected(0)"
                >Gratis
                </v-chip>
                <v-chip class="ma-1"
                        v-for="(price, index) in deliverPrices"
                        :key="index"
                        @click="goSetDeliveryPriceStatic(price)"
                        :color="isDeliverPriceSelected(price)? 'black' : 'gray'"
                        :dark="isDeliverPriceSelected(price)"
                >{{ price | currency }}
                </v-chip>
                <v-chip class="ma-1" @click="goOtherPrice()">Otro </v-chip>
                <v-col md="8">
                  <v-text-field
                    v-if="otherPrice == true"
                    outlined
                    prepend-inner-icon="mdi-currency-usd"
                    label="Valor del domicilio"
                    color="black"
                    type="number"
                    :rules="numberRuleDeliveryPrice"
                    @change="(v) => goSetDeliveryPrice(parseInt(v))"
                  ></v-text-field>
                </v-col>

                <validation-provider v-slot="{ errors }"
                                     rules="required|digits:10"
                                     name="celular"
                >
                  <v-text-field outlined
                                class="mt-3"
                                prepend-inner-icon="mdi-phone"
                                v-model="cart.customerPhone"
                                label="Teléfono del cliente"
                                color="black"
                                :error-messages="errors"
                  ></v-text-field>
                </validation-provider>

                <validation-provider v-slot="{ errors }"
                                     rules="required|min:3"
                                     name="nombre"
                >
                  <v-text-field outlined
                                prepend-inner-icon="mdi-account"
                                v-model="cart.customerName"
                                label="Nombre del cliente"
                                color="black"
                                :error-messages="errors"
                  ></v-text-field>
                </validation-provider>

                <validation-provider v-slot="{ errors }"
                                     rules="required"
                                     name="dirección de entrega"
                >
                  <v-text-field outlined
                                prepend-inner-icon="mdi-map-marker"
                                v-model="cart.customerAddress"
                                label="Dirección de entrega"
                                color="black"
                                :error-messages="errors"
                  ></v-text-field>
                </validation-provider>

                <validation-provider v-slot="{ errors }"
                                     rules="min:3"
                                     name="notas"
                >
                  <v-textarea outlined
                              prepend-inner-icon="mdi-comment"
                              v-model="cart.notes"
                              label="Comentario/Notas"
                              rows="2"
                              color="black"
                              :error-messages="errors"
                  ></v-textarea>
                </validation-provider>
              </v-col>

              <v-col>
                <p>MÉTODO DE PAGO</p>
                <v-radio-group v-model="cart.paymentMethod"
                               row
                >
                  <v-radio label="EFECTIVO"
                           value="cash"
                           color="black"
                  ></v-radio>
                  <v-radio label="TRANSFERENCIA"
                           value="transfer"
                           color="black"
                  ></v-radio>
                  <v-radio
                    label="DATAFONO"
                    value="cardReader"
                    color="black"
                  ></v-radio>
                </v-radio-group>

                <p>SOLICITAR FESTY RIDER
                  <v-icon class="ma-0"
                          color="black"
                  >mdi-bike
                  </v-icon>
                </p>
                <v-radio-group v-model="cart.hasRider"
                               row
                >
                  <v-radio label="NO"
                           :value="false"
                           color="black"
                  ></v-radio>
                  <v-radio label="SI"
                           :value="true"
                           color="black"
                  ></v-radio>
                </v-radio-group>

                <p class="font-weight-bold">TOTAL A COBRAR: {{ cart.totalPrice | currency }}</p>
              </v-col>
            </v-row>

            <v-row>
              <v-spacer></v-spacer>
              <v-btn dark
                     class="ma-1"
                     @click="closeSummarySaleModal()"
              >Cancelar
              </v-btn>

              <v-btn type="submit"
                     color="green"
                     class="white--text ma-1"
                     :disabled="invalid"
              >Registrar venta
              </v-btn>
            </v-row>
          </form>
        </validation-observer>
      </v-card>
    </v-dialog>
    <!-- END SUMMARY SALE MODAL -->

    <!-- START CONFIRM SALE MODAL -->
    <v-dialog v-model="modal.showConfirmSale"
              max-width="350"
    >
      <v-card>
        <v-card-title class="headline">
          Desea registrar la venta?
        </v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn dark
                 @click="closeConfirmSaleModal()"
          >No
          </v-btn>

          <v-btn dark
                 color="green"
                 @click="saveSale()"
                 :loading="sending.sale"
          >Si
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- END CONFIRM SALE MODAL -->

    <!-- START DETAIL PRODUCT MODAL -->
    <v-dialog v-model="modal.showDetailProduct"
              max-width="600"
              persistent
              scrollable
    >
      <v-card>
        <v-toolbar color="transparent">

          <v-btn icon
                 color="black"
                 @click="closeDetailProductModal()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-toolbar-title>{{ detailProduct.name }}</v-toolbar-title>
        </v-toolbar>

        <v-img :src="detailProduct.imageUrl"
               height="250"
        ></v-img>

        <v-card-text>
          <v-row align="center"
                 class="mx-0"
          >
            <div class="grey--text display-1 mt-4">{{ detailProduct.price | currency }}</div>
          </v-row>

          <div class="my-4">{{ detailProduct.description !== undefined ? detailProduct.description.substr(0,200) : 'Ha ocurrido un error' }}...</div>

          <div class="my-4"

          >
            <v-row>
              <p class="font-weight-bold"
                 v-if="productHasAdditives(detailProduct) && !isProductInTheCart(detailProduct)"
              >Debe estar el producto en el carrito para poder seleccionar las opciones</p>

              <v-col cols="12"
                     v-for="(item, index) in detailProduct.additives"
                     :key="index"
              >

                <product-additives :title="item.title"
                                   :product-id="detailProduct.id"
                                   :multiple="item.multiple"
                                   :required="item.mandatory"
                                   :options="item.options"
                                   :disabled="!isProductInTheCart(detailProduct)"
                                   v-on:update:totalPriceAdditives="updateTotalPriceAdditiveOfProductInCart(detailProduct, index, $event)"
                />
              </v-col>
            </v-row>
          </div>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <touch-spin cols="6"
                      center
                      :initial-value="getQuantityOfThisProductInCart(detailProduct)"
                      v-on:decrement="decrementProductQuantity(detailProduct)"
                      v-on:increment="incrementProductQuantity(detailProduct)"
          />

          <v-row class="justify-space-around">
            <v-btn color="success"
                   v-show="isProductInTheCart(detailProduct)"
                   @click="closeDetailProductModal()"
            >
              <v-icon>mdi-plus</v-icon>
              Agregar
            </v-btn>

            <p class="font-weight-bold">Total: {{ getSubtotalPriceOfThisProductInCart(detailProduct) | currency }}</p>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- END DETAIL PRODUCT MODAL -->

  </v-container>
</template>

<script>
import Parse from "parse"
import {ValidationProvider, ValidationObserver} from "vee-validate"
import {extend} from 'vee-validate'
import {required, digits, min} from 'vee-validate/dist/rules'
import {localize} from 'vee-validate'
import es from 'vee-validate/dist/locale/es.json'
import TouchSpin from "@/components/utils/TouchSpin";
import ProductAdditives from "@/components/utils/ProductAdditives";
//import Printer from "@/plugins/utils/printer";

extend('required', required)
extend('min', min)
extend('digits', digits)
localize('es', es)

export default {
  name: "Pos",
  components: {
    ProductAdditives,
    TouchSpin,
    ValidationProvider,
    ValidationObserver
  },
  props: {
    merchantId: {
      type: String,
      required: true
    },
    merchantName: {
      type: String,
      required: true
    }
  },
  computed: {
    productsFiltered() {
      return this.products.filter(value => this.canShowThisProduct(value.category))
    },
    /*services() {
      return this.$store.state.webBluetooth.services
    },
    characteristics() {
      return this.$store.state.webBluetooth.characteristics
    }*/
  },
  data: () => {
      return {
       numberRuleDeliveryPrice: [
        (v) => Number(v) > 0 || "Valor tiene que ser mayor a 0",
      ],
      otherPrice: false,

      cart: {
        products: [],
        customerId: '',
        customerPhone: '',
        customerName: '',
        customerAddress: '',
        hasRider: false,
        paymentMethod: 'cash',
        notes: '',
        subtotalPrice: 0,
        deliveryPrice: 0,
        totalPrice: 0
      },
      modal: {
        showCart: false,
        showConfirmSale: false,
        showSummarySale: false,
        showDetailProduct: false
      },
      loading: {
        customers: true,
        products: true
      },
      sending: {
        sale: false
      },
      customers: [],
      products: [],
      categories: [],
      detailProduct: {},
      deliverPrices: [5000, 4000, 3000, 2000, 1500, 1000],
      filterByCategory: 'Todo',
      searchCustomer: null
    }
  },
  watch: {
    'cart.subtotalPrice': {
      handler(after) {
        this.cart.totalPrice = after + this.cart.deliveryPrice
      },
      deep: true
    },

    'cart.deliveryPrice': {
      handler(after) {
        this.cart.totalPrice = after + this.cart.subtotalPrice
      },
      deep: true
    },
  },
  mounted() {
    this.getCustomers()
    this.getProducts()
  },
  methods: {
    getAutoCompleteCustomerText(item) {
      return `${item.name} (${item.phone})`
    },

    changeAutoCompleteCustomer() {
      let customer = this.findCustomerById(this.cart.customerId)

      this.updateCartCustomerInfo(customer)
    },

    updateCartCustomerInfo(customer) {
      if (customer) {
        this.cart.customerName = customer.name
        this.cart.customerAddress = customer.address
        this.cart.customerPhone = customer.phone
      }
    },

    goOtherPrice() {
      this.otherPrice = true;
    },

    goSetDeliveryPriceFree() {
      this.setDeliveryPrice(0);
      this.otherPrice = false;
    },

    goSetDeliveryPriceStatic(price) {
      this.setDeliveryPrice(price);
      this.otherPrice = false;
    },

    goSetDeliveryPrice(price) {
      if (price <= 0) {
        this.$snotify.error(
          `El valor del domicilio tiene que ser mayor a 0`,
          "Domicilio",
          {
            timeout: 4000,
            preventDuplicates: true,
          }
        );
      } else {
        this.setDeliveryPrice(price);
      }
    },

    updateTotalPriceAdditiveOfProductInCart(product, index, total) {
      if (this.isProductInTheCart(product)) {
        let productIndexInCart = this.findProductIndexInCart(product)

        this.cart.products[productIndexInCart].additivesPrices[index] = total
      }

      this.updateSubtotalPriceCart()
    },

    openCartModal() {
      this.modal.showCart = true
    },

    closeCartModal() {
      this.modal.showCart = false
    },

    openConfirmSaleModal() {
      this.modal.showConfirmSale = true
    },

    closeConfirmSaleModal() {
      this.modal.showConfirmSale = false
    },

    openSummarySaleModal() {
      this.modal.showSummarySale = true
    },

    closeSummarySaleModal() {
      this.modal.showSummarySale = false;
      this.otherPrice = false;
    },

    openDetailProductModal(product) {
      this.detailProduct = product
      this.modal.showDetailProduct = true
    },

    closeDetailProductModal() {
      this.modal.showDetailProduct = false
    },

    setDeliveryPrice(price) {
      this.cart.deliveryPrice = price
    },

    isDeliverPriceSelected(price) {
      return this.cart.deliveryPrice === price
    },

    productHasAdditives(product) {
      if (product.modifiers === undefined) {
        return false
      }

      if (this.isArrayEmpty(product.modifiers)) {
        return false
      }

      return true
    },

    saveSale() {
      this.setSendingSaleAsTrue()
      /* eslint-disable */
      this.runParseCloud('registerPOSSale', this.getRegisterPOSSaleParams())
          .then(response => {
            this.closeConfirmSaleModal()
            this.closeSummarySaleModal()
            this.clearCart()
            //this.printOrder(response.attributes)
          })
          .catch(error => this.showErrorMessage('Error', error.message))
          .finally(() => this.setSendingSaleAsFalse())
    },

    getRegisterPOSSaleParams() {
      return {
        store: this.merchantId,
        items: JSON.stringify(this.cart.products),
        tags: '',
        promoCode: '',
        paymentMethod: this.cart.paymentMethod,
        address: this.cart.customerAddress,
        notes: this.cart.notes,
        phone: this.cart.customerPhone,
        alias: this.cart.customerName,
        storeName: this.merchantName,
        deliverCost: this.cart.deliveryPrice,
        total: this.cart.totalPrice,
        discount: 0,
        requestRider: this.cart.hasRider
      }
    },

    clearCart() {
      this.cart.products = []
      this.cart.customerId = ''
      this.cart.customerPhone = ''
      this.cart.customerName = ''
      this.cart.customerAddress = ''
      this.cart.hasRider = false
      this.cart.paymentMethod = 'efectivo'
      this.cart.notes = ''
      this.cart.subtotalPrice = 0
      this.cart.deliveryPrice = 0
      this.cart.totalPrice = 0
    },

    incrementProductQuantity(product) {
      if (this.isProductInTheCart(product)) {
        this.incrementProductQuantityInCartByIndex(this.findProductIndexInCart(product))
        this.updateSubtotalPriceCart()
      } else {
        this.addProductToCart(product)
      }
    },

    decrementProductQuantity(product) {
      if (this.getQuantityOfThisProductInCart(product) === 1) {
        this.removeProductOfCart(product)
      }

      if (this.isProductInTheCart(product)) {
        this.decrementProductQuantityInCartByIndex(this.findProductIndexInCart(product))
      }

      this.updateSubtotalPriceCart()
    },

    addProductToCart(product) {
      let productCart = {
        id: product.id,
        product: product.id,
        name: product.name,
        price: product.price,
        quantity: 1,
        withCombo: product.comboOption,
        comboPrice: product.comboPrice,
        comboNotes: product.comboNotes,
        additivesPrices: []
      }

      if (this.productHasAdditives(product)) {
        productCart.additives = product.modifiers
      }

      this.cart.products.push(productCart)
      this.updateSubtotalPriceCart()
    },

    setSendingSaleAsTrue() {
      this.sending.sale = true
    },

    setSendingSaleAsFalse() {
      this.sending.sale = false
    },

    hasCartProducts() {
      return this.cart.products.length > 0
    },

    getProductsQuantityInCart() {
      return this.cart.products.length
    },

    incrementProductQuantityInCartByIndex(index) {
      this.cart.products[index].quantity += 1
    },

    decrementProductQuantityInCartByIndex(index) {
      this.cart.products[index].quantity -= 1
    },

    updateSubtotalPriceCart() {
      this.cart.subtotalPrice = 0

      this.cart.products.forEach(value => {
        this.cart.subtotalPrice += ((value.price * value.quantity) + this.getTotalAdditivePriceOfProduct(value))
      })
    },

    getTotalAdditivePriceOfProduct(product) {
      let total = 0

      if (this.isProductInTheCart(product)) {
        let productIndexInCart = this.findProductIndexInCart(product)

        this.cart.products[productIndexInCart].additivesPrices.forEach(value => total += value)
      }

      return total
    },

    removeProductOfCart(product) {
      this.cart.products.splice(this.cart.products.indexOf(product), 1)
      this.updateSubtotalPriceCart()
    },

    isProductInTheCart(product) {
      return this.findProductInCart(product) !== undefined
    },

    findProductInCart(product) {
      return this.cart.products.find(value => value.id === product.id)
    },

    findProductIndexInCart(product) {
      return this.cart.products.findIndex(value => value.id === product.id)
    },

    findCustomerById(customerId) {
      return this.customers.find(value => value.id === customerId)
    },

    getQuantityOfThisProductInCart(product) {
      if (this.isProductInTheCart(product)) {
        let productCart = this.findProductInCart(product)

        return productCart.quantity;
      }

      return 0;
    },

    getSubtotalPriceOfThisProductInCart(product) {
      if (this.isProductInTheCart(product)) {
        let productCart = this.findProductInCart(product)

        return (productCart.price * productCart.quantity) + this.getTotalAdditivePriceOfProduct(product);
      }

      return 0;
    },

    filterProductsBy(category) {
      this.filterByCategory = category
    },

    canShowThisProduct(category) {
      return category === this.filterByCategory || this.filterByCategory === 'Todo'
    },

    getCustomers() {
      this.fetchCustomers(this.merchantId)
          .then(response => {
            this.customers = this.transformClientsResponseToAutoCompleteItems(response)
          })
          .catch(error => {
            this.showErrorMessage('Error', error.message)
          })
          .finally(() => this.setLoadingCustomersAsFalse())
    },

    getProducts() {
      this.fetchProducts(this.merchantId)
          .then(response => {
            this.products = this.transformProductsResponseToProducts(response)
          })
          .catch(error => {
            this.showErrorMessage('Error', error.message)
          })
          .finally(() => this.setLoadingProductsAsFalse())
    },

    fetchCustomers(store) {
      let params = {
        store: store
      }

      return this.runParseCloud('listAllCustomersST', params)
    },

    fetchProducts(store, status = 'active') {
      let params = {
        id: store,
        status: status
      }

      return this.runParseCloud('getMyProductsBO', params)
    },

    transformClientsResponseToAutoCompleteItems(response) {
      return response.map((value) => {
        return {
          id: value.id,
          name: value.attributes.name,
          address: value.attributes.address,
          phone: value.attributes.phone,
        }
      })
    },

    transformProductsResponseToProducts(response) {
      return response.map((value) => {
        let product = Object.create(value.attributes)
        product = Object.assign(product, {id: value.id})

        this.addCategoryIfNotExists(product.category)

        return product
      })
    },

    addCategoryIfNotExists(category) {
      if (this.doesntHaveCategory(category)) {
        this.categories.push(category)
      }
    },

    doesntHaveCategory(category) {
      if (this.isArrayEmpty(this.categories)) {
        return true
      }

      return this.categories.findIndex(value => value === category) === -1
    },

    setLoadingCustomersAsFalse() {
      this.loading.customers = false
    },

    setLoadingProductsAsFalse() {
      this.loading.products = false
    },

    findCharacteristicsByServiceAndUuid(service, uuid) {
      return this.$store.getters['webBluetooth/characteristicForService'](service, uuid)
    },

    hasServices() {
      return this.services.length > 0
    },

    hasCharacteristics() {
      return this.characteristics.length > 0
    },

    /*printOrder(order) {
      if (this.hasServices() && this.hasCharacteristics()) {
        let characteristic = this.findCharacteristicsByServiceAndUuid(this.services[0], process.env.VUE_APP_PRINTER_CHARACTERISTIC_UUID)

        if (characteristic !== undefined) {
          let printer = new Printer()
          printer.addFestyTitle()
              .addProductTableHeader()

          order.items.forEach(item => {
            printer.addProductToTable(
                item.attributes.name,
                `${item.attributes.quantity}`,
                `${this.getNumberFormat(item.attributes.price)}`
            )
          })

          printer.addSubtotalToTable(`${this.getNumberFormat(order.total - order.deliveryCost - order.discount)}`)
              .addTotalToTable(`${this.getNumberFormat(order.total)}`)

          this.writeByCharacteristic(characteristic, printer.text)
        }
      }
    },*/

    writeByCharacteristic(characteristic, text) {
      let br = '\u000A\u000A\u000A\u000D'

      return this.$store.dispatch('webBluetooth/writeCharacteristic', {
        characteristic: characteristic,
        value: new TextEncoder('utf-8').encode(text + br)
      })
    },

    getNumberFormat(number) {
      return new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0})
          .format(number)
    },

    isArrayEmpty(array) {
      return array.length === 0
    },

    isFilteringCategories(category) {
      return this.filterByCategory === category
    },

    runParseCloud(name, params, options = {}) {
      return Parse.Cloud.run(name, params, options)
    },

    showErrorMessage(title, message) {
      this.$snotify.error(message, title, {timeout: 4000, preventDuplicates: true});
    }
  }
}
</script>
